<template lang="pug">
v-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl" scrollable fluid)
  v-card.primary--text
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10.text-capitalize {{ $t('pending_invites') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider

    v-card-text.pt-6.px-6.pb-16.primary--text
      .text-lg.font-medium.mb-8 {{ $t('invited_list') }}
      .text-center(v-if="isLoading")
        v-progress-circular(width=2 size=50 color="primary" indeterminate)
      .mb-4(v-else v-for="member in members" :key="member.id")
        .d-flex.align-center
          .text-md {{ member.email }}
          v-spacer
          v-btn.button-sm.mr-2(outlined color="primary" @click="clickResend(member)" :loading="isLoadingResend") {{ $t('resend') }}
          v-btn(icon @click="clickDelete(member)")
            eva-icon(name="trash-2-outline" height="20" :fill="$vuetify.theme.themes[$theme].primary400")
        v-divider.mt-4
      .pb-16
    v-divider

    v-card-actions.px-6.py-3
      v-spacer
      v-btn.button-md.white--text(@click="showDialog = false" color="info500" depressed) {{ $t('done') }}

    .dialogs
      y-dialog(v-if="showDeleteDialog" v-model="showDeleteDialog" persistent max-width=568 content-class="round-2xl")
        v-card
          v-card-title.px-4
            v-spacer
            .text-xl.font-bold.ml-10 {{ $t('remove_invites') }}
            v-spacer
            v-btn(icon @click="showDeleteDialog = false")
              v-icon mdi-close
          v-divider
          v-card-text.py-8.primary--text
            .text-lg.font-medium.mb-8 {{ $t('remove_invites_confirmation_1') }}
            .text-md.mb-2 {{ $t('remove_invites_confirmation_2') }}
            .text-md {{ $t('click_confirm_to_proceed') }}
          v-divider
          v-card-actions.px-6.py-4
            v-spacer
            v-btn.button-md.primary400--text(@click="showDeleteDialog = false" text) {{ $t('cancel') }}
            v-btn.button-md.white--text(color="danger500" depressed @click="deleteInvitation") {{ $t('confirm') }}
</template>
  
<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  props: ['open'],
  data: () => ({
    isLoading: false,
    isLoadingResend: false,
    members: [],
    showDeleteDialog: false,
    selectedMember: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    ...mapState('user', ['member']),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  created() {
    this.fetchInvitations()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchInvitations () {
      this.isLoading = true
      this.$axios.get(`/invitations/?company=${this.company.id}&role=5&page_size=-1&accepted=false&ordering=id`, )
        .then(resp => {
          this.members = resp.data.results
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    sendEmailInvitation (id) {
      this.isLoadingResend = true
      this.$axios.post(`/invitations/${id}/send/?company=${this.company.id}`)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.invitation_sent')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoadingResend = false
        })
    },
    clickResend (member) {
      this.selectedMember = member
      this.sendEmailInvitation(member.id)
    },
    clickDelete (member) {
      this.selectedMember = member
      this.showDeleteDialog = true
    },
    deleteInvitation () {
      this.$axios.delete(`/invitations/${this.selectedMember.id}/?company=${this.company.id}`)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.invitation_deleted')])
          this.members = this.members.filter(i => i.id !== this.selectedMember.id)
          this.selectedMember = null
          this.showDeleteDialog = false
          this.showDialog = false
          this.$emit('updated')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.openDeleteDialog = false;
        })
    }
  }
}
</script>